<template>
    <div class="features-area pt-75 pb-75 bg-F7F7FF">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="features-content">
                        <span class="sub-title text-uppercase">Add On Features</span>
                        <h2>{{ app_add_ons?.title }}</h2>
                        <p v-if="app_add_ons?.description">{{ app_add_ons.description }}</p>
                         <div class="btn-box">
                            <a class="default-btn" :href="'/contact'">Contact Us</a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 py-0" v-if="app_add_ons?.features?.length > 0">
                    <div class="list-of-features">
                        <div class="row justify-content-center row-feature" style="row-gap: 10px;">
                            <div class="col-lg-6 col-sm-6 col-md-6 service-item" v-for="(feature,index) in app_add_ons.features.slice(0, 4)" :key="feature?.title">
                                <div class="features-item with-border">
                                    <div class="icon">
                                        <i :class="iconClasses[index % iconClasses?.length]"></i>
                                    </div>
                                    <h3>{{ feature.title }}</h3>
                                    <p>{{ feature.description }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppAddOnsSection',
    props: {
        app_add_ons: {
            type: Object,
            required: true
        }
    },
    data() {
    return {
      iconClasses: ['ri-eye-line','ri-smartphone-line','ri-award-line','ri-fingerprint-line','ri-vip-diamond-line']}}
}
</script> 